import React, { createContext, useState, useContext } from 'react';
import {useDispatch} from "react-redux";
import { login, logout } from '../Store/actions/authActions';


export const AuthContext = createContext();


export const AuthProvider = ({ children }) => {
  const dispatch = useDispatch(); // Use Redux's useDispatch hook
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [loginFailed, setLoginFailed] = useState(false);
  const [user, setUser] = useState(null);

  const handleLogin = async (username, password) => {
    await dispatch(login(username, password, setIsLoggedIn, setLoginFailed));
  };

  const handleFailedLogin = () => {
    setLoginFailed(true);
  }

  const handleLogout = async () => {
    await dispatch(logout());
    setIsLoggedIn(false);
    setUser(null);
  };

  const value = { isLoggedIn, user, handleLogin, handleLogout, loginFailed, handleFailedLogin };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};
